import type { ReactNode } from 'react'

export type AuthLayoutProps = {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <section className="hidden flex-col justify-between border-r-2 border-ink bg-ink px-10 py-12 text-surface lg:flex">
        <div>
          <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-sidebar-muted">
            Superadmin · Internal
          </p>
          <h1 className="mt-4 font-display text-4xl font-medium tracking-[-0.02em]">
            Onn Record
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-sidebar-text">
            Platform control for agency accounts, access, and operational
            oversight.
          </p>
        </div>
        <p className="text-xs text-sidebar-muted">
          Authorized personnel only. All actions are logged.
        </p>
      </section>

      <section className="flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md border-2 border-ink bg-surface p-8">
          {children}
        </div>
      </section>
    </div>
  )
}
